define('LNRS/Components/Content/Features/ThreeLvlTab',["jquery"], function ($) {

    function ThreeLvlTab(scope) {

        //$('.level-two > .panel > .panel-heading > a').matchHeight();

        //fix scroll position for opened accordion panes
        setTimeout(function() {
                $('.panel-collapse').on('shown.bs.collapse',
                    function(e) {
                        e.stopPropagation();
                        var $panel = $(this).closest('.panel');
                        $('html,body').animate({
                                scrollTop: $panel.offset().top - 90
                            },
                            500);
                    });
            },
            1000);

        // user's request to stack 2 by 2 if there are 4 tabs
        // 
        $('.level-two > .panel > .panel-collapse').on('shown.bs.collapse', function (e) {
            var $this = $(this);
            if ($this.find('.level-three > .panel').length == 4) {
                $this.find('.level-three > .panel').css('max-width', '370px');
            }
        });
    /*
                        $('.score-accordion.level-three > .panel-default > .panel-heading > a').matchHeight();
                        $('.score-accordion.level-three > .panel-default > .panel-heading > a').addClass('collapsed');
        */
        $('.level-two > .panel > .panel-collapse').on('hidden.bs.collapse',
            function(e) {
                closeAllPanels();
                if ($(window).width() > mobileBreakpoint) {
                    var $panel = $(this).closest('.panel');
                    $panel.css('margin-bottom', '10px');
                }
            });

        $('.level-two > .panel > .panel-collapse').on('shown.bs.collapse',
            function(e) {
                e.stopPropagation();
                if ($(window).width() > mobileBreakpoint) {
                    var $panelHead = $(this).prev('.panel-heading');
                    var $panelBody = $(this);
                    var $panel = $(this).closest('.panel');
                    $('.level-two > .panel').css('margin-bottom', '10px');
                    $panelBody.css('top', ($panelHead.height() + $panelHead.position().top + 20) + 'px');
                    $panel.css('margin-bottom', ($panelBody.height() + 60) + 'px');

                    //$('.score-accordion.level-three > .panel-default > .panel-heading > a').matchHeight();
                }
            });

        /*
        *  for desktop only - position opened tab/accordion panel
        *  below the current ROW, and move other rows DOWN
        *  row can have max of 3 elements
        */
        var mobileBreakpoint = 992;
        // do this only for larger screens
        $('.level-three .panel-collapse').on('hidden.bs.collapse',
            function(e) {
                e.stopPropagation();
                if ($(window).width() > mobileBreakpoint) {
                    var $panel = $(this).closest('.panel');
                    $panel.css('margin-bottom', '10px');
                    var $parentPanel = $panel.parents('.panel-default');
                    var $currentPanel = $panel.parents('.panel-collapse');
                    $parentPanel.css('margin-bottom', $currentPanel.height() + 'px');
                }
            });

        $('.level-three .panel-collapse').on('shown.bs.collapse',
            function(e) {
                e.stopPropagation();
                if ($(window).width() > mobileBreakpoint) {
                   // $('.lnrs-tab-highlight .score-style-box').matchHeight();
                    var $panelHead = $(this).prev('.panel-heading');
                    var $panelBody = $(this);
                    var $panel = $(this).closest('.panel');
                    var $parentPanel = $panel.parents('.panel-default');
                    var $parentBody = $panel.parents('.panel-collapse');
                    $('.level-three > .panel').css('margin-bottom', '10px');
                    var closedHeight = parseInt($parentBody.height());
                    $panelBody.css('top', ($panelHead.height() + $panelHead.position().top + 20) + 'px');
                    $panel.css('margin-bottom', ($panelBody.height() + 60) + 'px');
                    // increase margin of parent panel
                    $parentPanel.css('margin-bottom', closedHeight + parseInt($panelBody.css('height')));
                }
            });

        /*
        * cleanup when switching from desktop to mobile
        *  and vice versa
        */
        var resizeTimer;
        var oldWinSize = $(window).width();
        var currWinSize = 0;

        function closeAllPanels() {
            $('.panel-heading > a').addClass('collapsed');
            $('.panel-collapse').removeClass('in');
            $('.panel.panel-default').css('margin-bottom', '10px');
        }

        closeAllPanels();

        $(window).on('resize', function(e) {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function() {
                    currWinSize = $(window).width();
                    if ((currWinSize >= mobileBreakpoint) && (oldWinSize < mobileBreakpoint)) {
                        // desktop now
                        closeAllPanels();
                    } else if ((currWinSize < mobileBreakpoint) && (oldWinSize >= mobileBreakpoint)) {
                        // mobile now
                        closeAllPanels();
                    }
                    oldWinSize = currWinSize;
                },
                250);
        });
    }

    return function init(args) {
        return new ThreeLvlTab(args.scope);
    };
});
